import { stripHtmlToPlainText } from "../../student-engagement/email/email.sent.util";

export const DEFAULT_SUCCESS_MESSAGE = "Thank you for your submission.";

export function resolveSuccessMessage(successMessage: string | null | undefined): string {
    if (successMessage == null) {
        return DEFAULT_SUCCESS_MESSAGE;
    }
    const trimmed = successMessage.trim();
    return trimmed.length > 0 ? trimmed : DEFAULT_SUCCESS_MESSAGE;
}

/** Plain-text success copy for toasts and other non-HTML surfaces. */
export function resolveSuccessMessagePlainText(successMessage: string | null | undefined): string {
    return stripHtmlToPlainText(resolveSuccessMessage(successMessage));
}
